import michelinLogo from 'brands/logos/michelin.png';
import decisivLogo from 'brands/logos/decisiv.png';

const TEMP_BRAND_VALUES_MAP = {
  michelin: {
    colors: {
      brand: {
        hover: '#1095F9',
        primary: '#27509B',
        secondary: '#FCE500',
        tertiary: '#00205B',
      },
    },
    logo: michelinLogo,
  },
  decisiv: {
    logo: decisivLogo,
  },
};

// eslint-disable-next-line import/prefer-default-export
export function getBrandValues({ brand }) {
  return new Promise((resolve) => {
    const brandValues = TEMP_BRAND_VALUES_MAP[brand] || {};
    setTimeout(
      () =>
        resolve({
          response: {
            body: {
              ...brandValues,
            },
          },
        }),
      16,
    );
  });
}



// WEBPACK FOOTER //
// ./redux/ui/api.js